import React, { memo } from 'react';

const PropertyInfo = ({ property, reminders, emergency }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">🏡 Property Info</h2>
      <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur rounded-lg shadow-md p-6 border border-orange-100 dark:border-gray-700">
        <h3 className="font-semibold text-lg mb-3">{property.name}</h3>
        <p className="text-gray-600 dark:text-gray-400 mb-2">{property.address}</p>
        <p className="text-gray-600 dark:text-gray-400 mb-4">VRBO #{property.vrbo}</p>
        <p className="text-gray-700 dark:text-gray-300 mb-4">{property.details}</p>
        
        <div className="bg-gradient-to-br from-orange-50 to-pink-50 dark:from-gray-700 dark:to-gray-800 rounded-lg p-4 border border-orange-200 dark:border-gray-600">
          <h4 className="font-semibold mb-2">🔑 Access Codes</h4>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-700 dark:text-gray-100">🚪 Gate:</span>
              <span className="font-mono font-bold text-lg text-orange-600 dark:text-orange-400">{property.access.gate}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-700 dark:text-gray-100">🏠 Front Door:</span>
              <span className="font-mono font-bold text-lg text-orange-600 dark:text-orange-400">{property.access.door}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-700 dark:text-gray-100">📶 WiFi:</span>
              <span className="font-mono font-bold text-lg text-orange-600 dark:text-orange-400">{property.access.wifi}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-yellow-50/90 dark:bg-yellow-900/20 backdrop-blur rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
        <h4 className="font-semibold mb-2">📋 Important Reminders</h4>
        <ul className="space-y-1">
          {reminders.map((reminder, idx) => (
            <li key={idx} className="text-sm text-gray-900 dark:text-gray-100">{reminder}</li>
          ))}
        </ul>
      </div>

      <div className="bg-red-50/90 dark:bg-red-900/20 backdrop-blur rounded-lg p-4 border border-red-200 dark:border-red-800">
        <h4 className="font-semibold mb-2">🚨 Emergency Contacts</h4>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span>🚒 Fire (non-emergency):</span>
            <a href={`tel:${emergency.fire}`} className="text-orange-600 dark:text-orange-400 font-semibold">
              {emergency.fire}
            </a>
          </div>
          <div className="flex justify-between">
            <span>🏥 Hospital:</span>
            <a href={`tel:${emergency.hospital}`} className="text-orange-600 dark:text-orange-400 font-semibold">
              {emergency.hospital}
            </a>
          </div>
          <div className="flex justify-between">
            <span>👮 Sheriff:</span>
            <a href={`tel:${emergency.sheriff}`} className="text-orange-600 dark:text-orange-400 font-semibold">
              {emergency.sheriff}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(PropertyInfo);